function loggerFunc(level) {
    return function(msg, props) {
        if (window.Rollbar && window.Rollbar[level]) {
            window.Rollbar[level](msg, props);
        }
        if (window.console) {
            if (window.console.log) {
                window.console.log(`${level} - ${msg}`);
            }
            if (window.console.dir && props) {
                window.console.dir(props);
            }
        }
    };
}

const logger = {
    critical: loggerFunc('critical'),
    error: loggerFunc('error'),
    warning: loggerFunc('warning'),
    info: loggerFunc('info'),
    debug: loggerFunc('debug')
}

export default logger;



// WEBPACK FOOTER //
// ./common/logger.js